import React, { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import Select, { components } from "react-select"
import makeAnimated from "react-select/animated"

import downIcon from "../../assets/Hub_Icons/downchevron.svg"
import { GlobalContext } from "../../context/GlobalContext"

export const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator { ...props }>
            <img
                alt="dropdown"
                src={ downIcon }
                className=""
                height={ "16px" }
                width={ "16px" }
            />
        </components.DropdownIndicator>
    )
}

export const animatedComponents = makeAnimated()

export const Option = (props) => {
    return (
        <>
            <components.Option { ...props }>
                <div className="flex items-center gap-1">
                    <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                        <input
                            className="peer w-[18px] h-[18px] absolute opacity-0 z-[1]"
                            type="checkbox"
                            checked={ props.isSelected }
                            onChange={ () => null }
                        />
                        <span
                            className={ `checkmark absolute h-[18px] w-[18px] 
                                 bg-white border rounded-[4px] border-primary-50  z-[2] 
                                  after:absolute after:hiddent after:content-[''] after:w-[6px] 
                                  after:h-[12px] after:rotate-45  after:border-b-[2px]  
                                  after:border-r-[2px] after:border-white after:left-[5px] after:top-[1px] ${
        props.isSelected ? "after:block !bg-primary-50" : ""}` }
                        ></span>
                    </div>
                    <label>{ props.label }</label>
                </div>
            </components.Option>
        </>
    )
}


export const customeStyles = {
    input: (styles) => ({
        ...styles,
        fontSize: "14px",
        lineHeight: "20px",
        color: "#34383F"
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    option: () => ({
        borderBottom: "1px solid #CED0D6",
        color: "#34383F",
        fontSize: "12px",
        lineHeight: "14px",
        backgroundColor: "white",
        padding: "8px 4px"
    }),
    menuList: () => ({
        maxHeight: "260px",
        padding: "12px",
        paddingBottom: "24px",
        overflow: "scroll"
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: "260px",
        paddiing: "0",
        borderColor: "#CED0D6",
        borderRadius: "8px",
        borderWidth: "1px"
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: "#F3F3F3",
        border: "1px solid #CED0D6",
        borderRadius: "13px",
        padding: "0 6px"
    })
}

const MultiSelect = (props) => {

    const {
        isDisabled, salesOrgEditSelectedData, isModalEdit
    } = props
    const { setSalesOrgination } = useContext(GlobalContext)
    const { options, name } = props
    const [selectedOption, setSelectedOption] = useState(null)
    const [isFocused, setIsFocused] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const selectChange = (selected) => {
        setSelectedOption(selected)
        setSalesOrgination(selected)
    }
    const handleFocus = () => {
        setIsFocused(true)
    }
    const handleBlur = () => {
        setIsFocused(false)
    }
    const handleMenuClose = () => {
        setMenuIsOpen(true)
    }
    const handleIsmenuOpen = () => {
        setMenuIsOpen(true)
    }
    const { t } = useTranslation()

    return (
        <div className={ `relative  ${isFocused ? "focused" : ""}` }>
            <Select
                isMulti
                name={ name }
                components={ {
                    Option,
                    DropdownIndicator,
                    animatedComponents        
                } }
                options={ options }
                styles={ customeStyles }
                value={ isModalEdit ? salesOrgEditSelectedData : selectedOption }
                onChange={ selectChange }
                className="basic-multi-select"
                classNamePrefix="select"
                closeMenuOnSelect={ false }
                hideSelectedOptions={ false }
                placeholder=""
                onFocus={ handleFocus }
                onMenuOpen={ handleIsmenuOpen }
                onBlur={ handleBlur }
                onMenuClose={ handleMenuClose }
                isDisabled={ isDisabled }
            />
            <label
                htmlFor="id"
                className={ `absolute flex text-sm text-secondary-50 
                     dark:text-secondary-50 duration-300 transform   
                     top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 
                     peer-focus:text-blue-600 peer-focus:dark:text-text-secondary-50  
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                     peer-placeholder-shown:top-1/2 peer-focus:top-2  peer-focus:-translate-y-4 
                     rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 
                     cursor-text font-['Avenir'] font-normal ${isFocused || (selectedOption 
                        && selectedOption?.length >= 1 || isModalEdit)  ?
            "!-translate-y-[21px top-[-11px] leading-[14px] scale-75" : "" }` }
            >
                <span className="text-red text-sm mr-1 flex leading-[14px]">*</span>
                { t("PsIndicator.salesOrg") }
            </label>
        </div>
    )
}

export default MultiSelect
